import Log from '../utils/Log';
import { Component } from "react";

import styles from './AppError.module.scss';

type AppErrorState = {
  hasError: boolean
}

type AppErrorProps = {
  children: React.ReactNode
}

class AppError extends Component<AppErrorProps, AppErrorState> {
  constructor(props: AppErrorProps) {
    super(props);

    this.state = {
      hasError: false
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: object) {
    Log.error('App', JSON.stringify({error, errorInfo}));
  }

  render () {
    return this.state.hasError ? (
      <div className={styles.AppError}>
        <h1>Something went wrong.</h1>
        <p>Please contact <a href="mailto:support@clusterx.com">support@clusterx.com</a> if you continue to have issues.</p>
        <button className={styles.RefreshButton} onClick={() => window.location.reload()}>Reload the App</button>
      </div>
    ) : this.props.children
  }
}

export default AppError;